import React from 'react';

import { RenderOrder, Segment2D } from '@paragon/three-shared';

import { useAppSelector } from '../../components/hooks';
import { getDistanceFormatterSelector } from '../../store/selectors/getDistanceFormatterSelector';
import { DistanceDimension, DistanceDimensionProps } from './DistanceDimension';
import { getTriangleData, segmentLength } from './getTriangleData';

interface Props {
  readonly segment: Segment2D;
}

export function ManualDistanceDimension({ segment }: Props) {
  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);
  const { hypotenuse, verticalLeg, horizontalLeg } = getTriangleData(segment);

  return (
    <>
      <DistanceDimension {...getLineProps(hypotenuse, false, distanceFormatter)} />
      {horizontalLeg && <DistanceDimension {...getLineProps(horizontalLeg, true, distanceFormatter)} />}
      {verticalLeg && <DistanceDimension {...getLineProps(verticalLeg, true, distanceFormatter)} />}
    </>
  );
}

/** The legs of the triangle are drawn dashed and unmarked so that the hypotenuse reads as the dimension. */
function getLineProps(
  segment: Segment2D,
  isLeg: boolean,
  distanceFormatter: (lengthInInches: number) => string,
): DistanceDimensionProps {
  return {
    segment,
    dashed: isLeg,
    styleVariant: isLeg ? 'xyComponent' : 'snap',
    showEndpointMarks: !isLeg,
    textFloat: 0.5,
    distanceFormatter,
    labelRenderOrder: isLeg ? RenderOrder.GlyphVisual_XYComponentDimension : RenderOrder.GlyphVisual_MainDimension,
    labelData: {
      firstNumber: segmentLength(segment),
      fontSize: 1.2,
      applyAntiZoomFactor: true,
    },
    orientText: true,
  };
}
